import { Component, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ICustomerLoginService, IHIPLoginService } from '@huge-monorepo/shared/interfaces';
import { SharedLoginSingletonService } from '@huge-monorepo/shared/services';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})

export class ResetPasswordComponent implements OnInit {
  loginService = this.sharedLoginService.getService();

  constructor(
    private route: ActivatedRoute,
    private sharedLoginService: SharedLoginSingletonService<ICustomerLoginService | IHIPLoginService>,
    private router: Router,
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.prk = params.get('prk');
    });
  }

  showSpinner = false;
  prk: any = '';

  formGroup: UntypedFormGroup = new UntypedFormGroup(
    {
      passwordControl: new UntypedFormControl('', Validators.compose([Validators.minLength(8), Validators.required])),
      confirmPasswordControl: new UntypedFormControl('', [Validators.required]),
    },

  );

  ngOnInit(): void {
    this.formGroup.get('passwordControl')?.valueChanges.subscribe((value) => {
      if (value !== this.formGroup.get('confirmPasswordControl')?.value) {
        this.formGroup.get('confirmPasswordControl')?.setErrors({ passwordsMismatch: true });
      }
    });

    this.formGroup.get('confirmPasswordControl')?.valueChanges.subscribe((value) => {
      if (value !== this.formGroup.get('passwordControl')?.value) {
        this.formGroup.get('confirmPasswordControl')?.setErrors({ passwordsMismatch: true });
      }
    });
  }

  validation_messages = {
    passwordControl: [
      { type: 'required', message: 'Password is required.' },
      {
        type: 'minLength',
        message: 'Please enter a password with more than 8 characters.',
      },
    ],
    matching_passwords: [{ type: 'areEqual', message: 'Password do not match.' }],
    confirmPasswordControl: [{ type: 'required', message: 'Confirm password is required.' }],
  };

  cancel() {
    this.router.navigate(['/']);
  }

  resetPassword(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    this.showSpinner = true;
    if (this.prk.length > 6) {
      let password = this.formGroup.get('passwordControl')?.value

      this.loginService.ResetPasswordRequest(this.prk, password).subscribe({
        error: (err) => {
          console.log(err);
          this.showSpinner = false;
        },
        complete: () => {
          this.showSpinner = false;
        },
      });
    }

  }
}
